jQuery(document).ready(function($){
    //Search Button Expension
    $('.top-search-button').one("click",function(e){
        e.preventDefault();
        $('.top-search-bar').show('fade');
    });

	//SLICK
	jQuery('.footer-custom-module-testimonials-container').slick({
        speed: 300,
        arrows:true,
        initialSlide: Math.floor(Math.random() * 4),
        slidesToScroll: 1,
        autoplay:false,
        responsive: [
            {
            breakpoint: 1279,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows:true,
                infinite: true,
            }
            },
            {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                arrows:true,
                slidesToScroll: 1,
            }
            },
            {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                arrows:true,
                slidesToScroll: 1
            }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });

    //increase / decrease font-size 
	var tags = $('p, li'),
	increaseSizeBtn = $(".sidemenu-text-size-increase"),
	decreaseSizeBtn = $(".sidemenu-text-size-decrease"),
	tagsMinFontSize = '18.5px',
	tagsMaxFontSize = '34.5px',
	changeValue = 2;
	decreaseSizeBtn.attr('disable', 'disable').css({'cursor' : 'no-drop'});

	increaseSizeBtn.on('click', function(ev) {
		ev.preventDefault();
		decreaseSizeBtn.attr('disable', 'false').css({'cursor' : 'pointer'});
		tags.each(function(index){ 
 			if($(tags[index]).css('font-size') < tagsMaxFontSize) {
				//console.log("Font size less than or equal to 28px.");
				var increaseFontVal = parseInt($(tags[index]).css('font-size')) + changeValue;
                $(tags[index]).css({'font-size': increaseFontVal});
                $('.sidemenu-book-tour-now p').css({'font-size': '13px'});
                $('#custom-sidemenu p').css({'font-size': '11px'});
				if(increaseFontVal >= parseInt(tagsMaxFontSize)) {
					increaseSizeBtn.attr('disable', 'disable').css({'cursor' : 'no-drop'});
                }
                if(increaseFontVal >= 25) {
                    $(tags[index]).css({'font-weight': '300'});
                    $(tags[index]).css({'letter-spacing': '-0.6px'});
                    $(tags[index]).css({'line-height': '1.65'});
                }
			}
		})
	});

	decreaseSizeBtn.on('click', function(ev) {
		ev.preventDefault();
		increaseSizeBtn.attr('disable', 'false').css({'cursor' : 'pointer'});
		tags.each(function(index){ 
			if($(tags[index]).css('font-size') >= tagsMinFontSize) {
				//console.log("Font size less than or equal to 28px.");
				var decreaseFontVal = parseInt($(tags[index]).css('font-size')) - changeValue;
				$(tags[index]).css({'font-size': decreaseFontVal});
				if(decreaseFontVal <= parseInt(tagsMinFontSize)) {
					decreaseSizeBtn.attr('disable', 'disable').css({'cursor' : 'no-drop'});
                }
                if(decreaseFontVal < 25) {
                    $(tags[index]).css({'font-weight': '400'});
                    $(tags[index]).css({'letter-spacing': '-0.45px'});
                    $(tags[index]).css({'line-height': '1.75'});
                }
			} 
		});
	});
})